import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import { InstallationTrainingProvidedPluginService } from './training-provided.service';
import * as _ from 'lodash';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { InstallationCustomerAttendeesMenuComponent } from '../../../menus';
import { LoadSpinnerService } from '../../../shared/services';
import { ModalComponent } from '../../../modal/modal.component';
import { ContactsModalComponent } from '../../../shared/components';

@Component({
    templateUrl: './training-provided-edit.component.html',
    standalone: false
})
export class InstallationTrainingProvidedEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  public menuComponent = InstallationCustomerAttendeesMenuComponent;

  private sub = new Subscription();
  private customerToRemove: number;

  @ViewChild('customerDeleteConfirm', { static: true }) customerDeleteConfirm: ConfirmComponent;
  @ViewChild('importCustomersModal') importCustomersModal: ModalComponent;
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationTrainingProvidedPluginService,
    protected fb: UntypedFormBuilder,
    protected loader: LoadSpinnerService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get customerAttendeesForms() {
    return <UntypedFormArray>this.editForm.controls['customerAttendees'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateTrainingProvided(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public import() {
    const control = <UntypedFormArray>this.editForm.controls['customerAttendees'];
    this.pluginService.getCustomerAttendees(this.inspectionId, this.pointId).subscribe((attendees) => {
      _.forEach(attendees, (el) => {
        control.push(this.initCustomer(el));
      });
    });
  }

  public add(data: any = null) {
    const control = <UntypedFormArray>this.editForm.controls['customerAttendees'];
    if (Array.isArray(data)) {
      _.forEach(data, (el) => {
        control.push(this.initCustomer(el));
      });
    } else if (data) {
      control.push(this.initCustomer(data));
    } else {
      control.push(this.initCustomer());
    }
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['customerAttendees'];
    control.removeAt(this.customerToRemove);
  }

  public openCustomerDeleteConfirm(i: number) {
    this.customerDeleteConfirm.open();
    this.customerToRemove = i;
  }

  public changeCheckboxValue(control) {
    control.setValue(!control.value);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      case 20:
        this.openImportContactsModal();
        break;
      default:
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      from: new UntypedFormControl(
        this.plugin.config.TrainingProvided?.From ? this.plugin.config.TrainingProvided.From : null
      ),
      to: new UntypedFormControl(
        this.plugin.config.TrainingProvided?.To ? this.plugin.config.TrainingProvided.To : null
      ),
      customerAttendees: this.fb.array([])
    });

    _.forEach(this.plugin.config.TrainingProvided?.CustomerAttendees, (attendee) => {
      this.customerAttendeesForms.push(this.initCustomer(attendee));
    });
  }

  openImportContactsModal() {
    this.loader.showSpinner();
    this.pluginService.getCustomerAttendees(this.inspectionId, this.pointId).subscribe((contacts) => {
      this.loader.hideSpinner();
      this.importCustomersModal.modalFooter = false;
      this.importCustomersModal.modalHeader = false;
      this.importCustomersModal.modalMessage = false;
      this.importCustomersModal.open(ContactsModalComponent, _.cloneDeep(contacts));
    });
  }

  private initCustomer(el?: any) {
    return this.fb.group({
      firstName: new UntypedFormControl(el && el.FirstName ? el.FirstName : ''),
      lastName: new UntypedFormControl(el && el.LastName ? el.LastName : ''),
      company: new UntypedFormControl(el && el.Company ? el.Company : ''),
      jobFunction: new UntypedFormControl(el && el.JobFunction ? el.JobFunction : ''),
      email: new UntypedFormControl(el && el.Email ? el.Email : ''),
      useOfDocumentation: new UntypedFormControl(el && el.UseOfDocumentation !== null ? el.UseOfDocumentation : false),
      safetyDevices: new UntypedFormControl(el && el.SafetyDevices !== null ? el.SafetyDevices : false),
      maintenance: new UntypedFormControl(el && el.Maintenance !== null ? el.Maintenance : false),
      machineOpAndControl: new UntypedFormControl(
        el && el.MachineOpAndControl !== null ? el.MachineOpAndControl : false
      )
    });
  }
}
